/* eslint-disable camelcase */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { RiPlayCircleLine } from 'react-icons/ri';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import Bookmark from './Bookmark';
import { useVerifyIsMobile } from './../../../../hooks/useVerifyIsMobile';
import './Episode.scss';
import { renderMaxLengthText } from '../../../../utils/renderMaxLengthText';
import { useNavigate } from 'react-router-dom';

const Episode = ({ data, bookmark, showBookmark, size, handleClick }) => {
  const navigate = useNavigate();
  const [loading, changeLoading] = useState(false);
  const translations = useSelector(state => state.translations);
  const { isMobile } = useVerifyIsMobile(768);
  const {
    image_still,
    episode_number,
    description,
    title,
    title_episode,
    id,
    title_uri,
    season_number,
  } = data;

  const handlePlayeContent = () => {
    if (handleClick) return handleClick();

    const eventInfo = {
      event: 'select_content',
      content_section: 'vcard',
      content_list: `temporada ${season_number}`,
      content_id: id,
      content_name: title,
      content_type: '',
      content_category: '',
      content_availability: '',
      content_episode: title_episode,
    };

    if (handleClick) return handleClick();

    navigate({
      pathname: `/${GetRegion()}/vcard/homeuser/${title_uri}/${id}`,
      state: { eventInfo },
    })
  };

  return (
    <article id={id} className="Episode">
      <div className="Episode__img-container">
        <button onClick={handlePlayeContent} type="button" disabled={loading}>
          <img src={image_still} className="Episode__img" alt="episode_img" />
          {!loading && !isMobile && (
            <div className="Episode__play-button">
              <RiPlayCircleLine />
            </div>
          )}
          {loading && (
            <div className="Episode__play-loading">
              <AiOutlineLoading3Quarters />
            </div>
          )}
          {showBookmark ? (
            <div className="Episode__bookmark">
              <Bookmark progress={bookmark} extraClass="serie" />
            </div>
          ) : null}
        </button>
        {size.width < 650 && (
          <div className="Episode__img-container__detail">
            <p className="Episode__detail__number">
              {translations.episode} {episode_number}
            </p>
            <p className="Episode__detail__title">
              {renderMaxLengthText(title_episode, 34)}
            </p>
          </div>
        )}
      </div>
      <div>
        {size.width > 650 && (
          <div className="Episode__number-container">
            <p className="Episode__number">
              {translations.episode} {episode_number}
            </p>
            <p className="Episode__title">
              {renderMaxLengthText(title_episode, 34)}
            </p>
            <p className="Episode__description">
              {renderMaxLengthText(description, 122)}
            </p>
          </div>
        )}
      </div>
      {size.width <= 650 && (
        <div className="Episode__description">
          {renderMaxLengthText(description, 122)}
        </div>
      )}
    </article>
  );
};

Episode.propTypes = {
  data: PropTypes.shape({
    image_still: PropTypes.string,
    title: PropTypes.string,
    season_number: PropTypes.string,
    image_small: PropTypes.string,
    description: PropTypes.string,
    episode_number: PropTypes.string,
    title_episode: PropTypes.string,
    description_large: PropTypes.string,
    groupId: PropTypes.string,
    id: PropTypes.string,
    title_uri: PropTypes.string,
  }),
  bookmark: PropTypes.shape({}),
  showBookmark: PropTypes.bool,
  size: PropTypes.object,
};

Episode.defaultProps = {
  data: {},
  bookmark: undefined,
  showBookmark: false,
};

export default Episode;
